var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTieri(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff2fb1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ff2fb1"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    x: 106.22,
    y: -31.729,
    width: 11.081,
    height: 29.514,
    ry: 0.14536,
    strokeWidth: 0.64393
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    x: 69.711,
    y: 12.812,
    width: 11.081,
    height: 35.174,
    ry: 0.14536,
    strokeWidth: 0.64393
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-45)",
    x: -9.8803,
    y: 80.598,
    width: 11.081,
    height: 29.514,
    ry: 0.14536,
    strokeWidth: 0.64393
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.092,
    cy: 56.129,
    r: 10.448,
    strokeWidth: 0.60118
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.95,
    cy: 51.106,
    r: 10.448,
    strokeWidth: 0.60118
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.011,
    cy: 82.048,
    r: 10.448,
    strokeWidth: 0.60118
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.126,
    cy: 92.295,
    r: 10.448,
    strokeWidth: 0.60118
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffdf00"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffdf00"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.66385 0 0 .66385 139.42 63.841)",
    d: "m-95.758-26.751-7.42-16.202-16.093-7.6523 16.202-7.42 7.6523-16.093 7.42 16.202 16.093 7.6523-16.202 7.42z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.90521 0 0 .90521 197.3 77.614)",
    d: "m-199.52-23.512-2.9701-11.514-11.514-2.9701 11.514-2.9701 2.9701-11.514 2.9701 11.514 11.514 2.9701-11.514 2.9701z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTieri);
export default __webpack_public_path__ + "static/media/tieri.b437ba5f0cf5822c5d00c611d9bb27c4.svg";
export { ForwardRef as ReactComponent };